import React from "react";
import "./Slider.css";

export default function Slider() {
  return (
    <section className="banner-wrapper">
      <picture>
        {/* ẢNH MOBILE (ưu tiên nếu màn hình ≤ 768px) */}
        <source
          media="(max-width: 768px)"
          srcSet="/2.png"   // ← ĐỔI ĐƯỜNG DẪN ẢNH MOBILE
        />

        {/* ẢNH PC */}
        <img
          src="/1.png"          // ← ĐỔI ĐƯỜNG DẪN ẢNH PC
          alt="Điện Lạnh Sài Gòn - Sửa chữa tại nhà"
          className="banner-img"
        />
      </picture>
    </section>
  );
}